export const MAX_INSTAGRAM_USERNAME_LENGTH = 30;

/**
 * Deliberately permissive: rejects only what Instagram cannot accept under any
 * circumstances, because a handle wrongly rejected here blocks a post the customer could
 * have published. Whether the account exists or is private is knowable only at publish
 * time, where Instagram answers 110/2207018.
 */
export function isValidInstagramUsername(value: string): boolean {
  const username = value.startsWith('@') ? value.slice(1) : value;

  if (!username || username.length > MAX_INSTAGRAM_USERNAME_LENGTH) {
    return false;
  }

  return /^[A-Za-z0-9._]+$/.test(username);
}
